import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { saveAs } from 'file-saver';
import { ModalService } from '../Modal/ModalService';
import { LoadingMaskService } from '../LoadingMask/LoadingMaskService';

@Injectable({
  providedIn: "root"
})
export class DocumentsHandlerService {
  constructor(private http: HttpClient, private modalService: ModalService, private router: Router, private loadingMaskService: LoadingMaskService) {
  }

  public DownloadFile(fileID: string, fileName: string, workflowInstanceId: string, subscriberNumber: string): void {

    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall', {}).subscribe((result: any) => {

      if (result.stateCode == 'I') {
        this.router.navigate(['validatepgponline']);
        return;
      } else {

        this.http.get('api/Documents/DownloadDocument', { params: { fileID: fileID, subscriberNumber: subscriberNumber, instanceID: workflowInstanceId }, responseType: 'blob' })
          .subscribe((res: any) => {
            //This defenetly is not a best practice
            //IE && Edge
            if ((<any>window.navigator).msSaveOrOpenBlob) {
              (<any>window.navigator).msSaveOrOpenBlob(res, fileName);
            }
            //Other browsers
            else {
              saveAs(res, fileName);
            }
          }, err => {
            //var baseModal = <models.BaseModalVM>{ isError: true, message: "BaseModal.ErrorDocumentoIntegrity" };
            var baseModal = <models.BaseModalVM>{ isError: true, message: "BaseModal.ErrorDownloadFile" };
            this.modalService.showModals([baseModal]);
          })
      }
    },
    error => this.loadingMaskService.setShowLoading(false)
    );
  }

  public DownloadFile_PM(fileID: string, fileName: string, workflowInstanceId: string, subscriberNumber: string, workflowCode: string ): void {

    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall', {}).subscribe((result: any) => {

      if (result.stateCode == 'I') {
        this.router.navigate(['validatepgponline']);
        return;
      } else {

        this.http.get('api/Documents/DownloadDocument_PM', { params: { fileID: fileID, subscriberNumber: subscriberNumber, instanceID: workflowInstanceId, workflowCode: workflowCode }, responseType: 'blob' })
          .subscribe((res: any) => {
            //This defenetly is not a best practice
            //IE && Edge
            if ((<any>window.navigator).msSaveOrOpenBlob) {
              (<any>window.navigator).msSaveOrOpenBlob(res, fileName);
            }
            //Other browsers
            else {
              saveAs(res, fileName);
            }
          }, err => {
            //var baseModal = <models.BaseModalVM>{ isError: true, message: "BaseModal.ErrorDocumentoIntegrity" };
            var baseModal = <models.BaseModalVM>{ isError: true, message: "BaseModal.ErrorDownloadFile" };
            this.modalService.showModals([baseModal]);
          })
      }
    },
      error => this.loadingMaskService.setShowLoading(false)
    );
  }
  //this receives a fileList but is only prepared to handle one file at a time
  public UploadFile(files: File, workflowInstanceId : string, numUtente : string ,docDesignationTypeCode: string) {
    var file = files;
    const formdata = new FormData();
    formdata.append('files', file);
    return this.http.post<models.DocumentUploadResultVM>('api/Documents/UploadDocument', formdata,
      { params: { workflowInstanceID: workflowInstanceId, numUtente : numUtente, docDesignationTypeCode: docDesignationTypeCode }, responseType: 'json' });
  }

  //this receives a fileList but is only prepared to handle one file at a time
  public UploadFile_PM(files: File, workflowInstanceId: string, numUtente: string, docDesignationTypeCode: string) {
    var file = files;
    const formdata = new FormData();
    formdata.append('files', file);
    return this.http.post<models.DocumentUploadResultVM>('api/Documents/UploadDocument_PM', formdata,
      { params: { workflowInstanceID: workflowInstanceId, numUtente: numUtente, docDesignationTypeCode: docDesignationTypeCode }, responseType: 'json' });
  }
  public CreateDocSyncEntries(documents: models.DocumentVM[],  ifedorchav: string) {
    return this.http.post('api/Documents/CreateDocSyncEntries', documents,
      { params: {  ifedorchav: ifedorchav } });
  }
}
